<div *ngIf="hasDpbAddon">
  <div class="dx-field">
    <div class="dx-field-label w-50">{{ 'WAWI-Felder befüllen' | translate }}</div>
    <dx-switch [(value)]="fillWawi"></dx-switch>
  </div>
  <div class="dx-field">
    <div class="dx-field-label w-50">{{ 'DPB-Bezeichnungen befüllen' | translate }}</div>
    <dx-switch [(value)]="fillDpb" (onValueChanged)="onFillDpbChanged()"></dx-switch>
  </div>
  <div *ngIf="loginService.hasAddonBauvista" class="dx-field">
    <div class="dx-field-label w-50">{{ 'Matchcode erzeugen' | translate }}</div>
    <dx-switch [(value)]="createMatchcode" [disabled]="!fillDpb"></dx-switch>
  </div>
</div>
